export const ENTITY_ASSISTANCE_PHONE_CONSULT_URL =
  'https://meetings.hubspot.com/swyftx-consult/swyftx-entity-assistance';
